/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { UnsplashPhotoList, UsableUnsplashPhoto } from '../../../../shared/models/images/unsplash-images.model';
import { ObservableResult } from '../../../../shared/store';
import { UnsplashImagesDataService } from './unsplash-images-data.service';

@Injectable()
export class MockUnsplashImagesDataService implements UnsplashImagesDataService {
  search(phrase: string, page: number): ObservableResult<UnsplashPhotoList> {
    return ObservableResult.ofSuccess();
  }

  download(url: string): ObservableResult<UsableUnsplashPhoto> {
    return ObservableResult.ofSuccess();
  }
}
